import React from 'react';
import PropTypes from 'prop-types';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import FormatDollarAmount from './FormatDollarAmount.jsx';

function QuotaBreakdownRow({ quota }) {
  const totalSamplesUsed = React.useMemo(
    () => Math.abs(quota.TotalSamplesUsed),
    [quota.TotalSamplesUsed]
  );

  return (
    <TableRow>
      <TableCell data-cy={`quota-category-${quota.CATEGORY}`}>{quota.CATEGORY}</TableCell>
      <TableCell data-cy={`quota-base-${quota.CATEGORY}`}>
        <FormatDollarAmount amount={quota.Base} />
      </TableCell>
      <TableCell data-cy={`quota-growth-${quota.CATEGORY}`}>
        <FormatDollarAmount amount={quota.TotalGrowth} />
      </TableCell>
      <TableCell data-cy={`quota-tpci-${quota.CATEGORY}`}>{quota.T_PCI}</TableCell>
      <TableCell data-cy={`quota-mb-${quota.CATEGORY}`}>
        <FormatDollarAmount amount={quota.moBase} />
      </TableCell>
      <TableCell data-cy={`quota-mg-${quota.CATEGORY}`}>
        <FormatDollarAmount amount={quota.moGoal} />
      </TableCell>
      <TableCell data-cy={`quota-dsamp-${quota.CATEGORY}`}>${quota.D_Samp.toFixed(3)}</TableCell>
      <TableCell data-cy={`quota-total-samples-${quota.CATEGORY}`}>
        <FormatDollarAmount amount={quota.TotalSamples} />
      </TableCell>
      <TableCell data-cy={`quota-total-samples-used-${quota.CATEGORY}`}>
        <FormatDollarAmount amount={totalSamplesUsed} />
      </TableCell>
      <TableCell data-cy={`quota-yearly-quota-${quota.CATEGORY}`}>
        <FormatDollarAmount amount={quota.YearlyQuota} />
      </TableCell>
      <TableCell data-cy={`quota-eoyb-${quota.CATEGORY}`}>
        <FormatDollarAmount amount={quota.EOYB} />
      </TableCell>
    </TableRow>
  );
}

QuotaBreakdownRow.propTypes = {
  quota: PropTypes.shape({
    CATEGORY: PropTypes.string.isRequired,
    Base: PropTypes.number.isRequired,
    TotalGrowth: PropTypes.number.isRequired,
    T_PCI: PropTypes.number.isRequired,
    moBase: PropTypes.number.isRequired,
    moGoal: PropTypes.number.isRequired,
    D_Samp: PropTypes.number.isRequired,
    TotalSamples: PropTypes.number.isRequired,
    TotalSamplesUsed: PropTypes.number.isRequired,
    YearlyQuota: PropTypes.number.isRequired,
    EOYB: PropTypes.number.isRequired,
  }).isRequired,
};

export default React.memo(QuotaBreakdownRow);
